var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 95,
    viewBox: "0 0 96 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 95,
    height: 95,
    rx: 47.5,
    fill: "#FBE8F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 25,
    width: 45,
    height: 45,
    fill: "url(#pattern0_46_920)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_46_920",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_46_920",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_46_920",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAChElEQVR4nO2dS24UMRRFPQE2AMJuyIwJWUbCFthAwC8SElMawpx0gKUxbBHfjPnsgM8I5BAmhdSh0x/Xcd6VPOlUyeeetlwepFUheDwej8fj8WAz3318U9FOlOyLkv1CjGifFfOssgdKKnBzcemqwvMsUIJayWk48tdASXtZttIIlLQWJRdtzSVekxWdX43hqX5+Kkp21K3o+Qgk/83Zg+e3uhUdRhYKJ76AIJz4AoJw4gsIwokvIAgnvoAgnPgCgnDiCwjCiS8gCCe+gCCc+AKCcOILCMKJLyAIJ76AIJz4AoJw4gsIwokvIAgnvoAgnPgCgnDiCwjCiS8gCCe+gCCc+AKCcOILCMKJLyAIJ76AIJz4AoJw4gsIwokvIAgnvoAgnPgCgnDiCwjCiS8gCCe+gCCc+AKCcC5dYO6/YdmOaCU7GoPsP79Vz6+7XdGCjEBJa1Fy0dZcoq/o1F6wbx3JRfse3TIbWYHRfpaUX5zuHEzqKMmm9TPfOtYsuiSbDr/Qc9m+R69X9Mfbloai53eeRRe9ZtGnOweTf7ao+4f3XPR2to6XLnojD0Ob+sNw06eOtL0RKGktSi7amkv0FZ3aC/atI7lo36NbZtEKLDF/K9HeKD55+CHYjUX3rjLv8G91rjqnoh1Xhq63jhLte7n7dO9/711l3kXXlYntV5ZuRSvayTL3rjLvZdeWZO/6FZ0YI1DSWpRctDWXeC1WdEn57TL3rjLvZdeWZO/7FR3HcerQJD8qMf/oVrQuZNezbItz9Fk83K0nn0VHu25ECzACJa1FyUVbc4l9rej6OqQRCNMVRon5U6CE/QonOw6UXPyj9wy1siPwpWQej8fj8Xg8YZjfT0rTvB6KbhoAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.670414067d7dca4f90a4a361e7268b17.svg";
export { ForwardRef as ReactComponent };